import React from 'react'
import { useParams } from 'react-router-dom'
import BudgetPlanningForm from './BudgetPlanningForm'

const BudgetPlanningEdit = () => {
  const { id } = useParams()
  
  return <BudgetPlanningForm mode="edit" budgetId={id} />
}

export default BudgetPlanningEdit

